const getData = () => document.getElementById('hw-tournament-data');
const nonNull = (value: string | null) => value === null ? '' : value;
const getAttr = (element: Element | null, key: string) => element ? nonNull(element.getAttribute(key)) : '';
const parseJson = (value: string | null) => value ? JSON.parse(value) : '';

export default {
  userId: () => getAttr(getData(), 'data-user'),
  heroesVersion: () => getAttr(getData(), 'data-heroes-version'),
  forumThreadId: () => getAttr(getData(), 'data-thread'),
  tournamentId: () => getAttr(getData(), 'data-tournament'),
  isOrganizer: () => parseJson(getAttr(getData(), 'data-organizer')),
  canChangeRequests: () => parseJson(getAttr(getData(), 'data-change-requests')),
};
